export const getEstimateStatusOptions = ({ hasLimit, userRole }) => {
    return [
        { value: "1", label: "作成中" },

        ...(hasLimit('approval')
            ? [
                { value: "2", label: "承認申請中" },
                {
                    value: "3",
                    label: "承認",
                    excludedRoles: ["staff", "sales"],
                },
            ]
            : []),

        { value: "4", label: "顧客提出済み" },
        { value: "5", label: "成約" },
        { value: "6", label: "見送り" },
    ].filter(opt => {
        if (!opt.excludedRoles) return true;
        return !opt.excludedRoles.includes(userRole);
    });
};